const types = {
  SET_CURRENT_RESUME: 'SET_CURRENT_RESUME'
};
const state = {
  currentResume: null
};

const mutations = {
  [types.SET_CURRENT_RESUME]: (state, value) => {
    state.currentResume = value;
  }
};

const actions = {};
const getters = {};

export default {
  namespaced: true,
  types,
  state,
  mutations,
  actions,
  getters
};
